import { BaseLayer } from "@common/build/types";
import b3b7 from "./library/b3b7.json";
import b3b7icon from "./library/b3b7.svg";
import b3b7f from "./library/b3b7f.json";
import b3b7ficon from "./library/b3b7f.svg";
import b7b3 from "./library/b7b3.json";
import b7b3icon from "./library/b7b3.svg";
import b7b3f from "./library/b7b3f.json";
import b7b3ficon from "./library/b7b3f.svg";
import bf from "./library/bf.json";
import bficon from "./library/bf.svg";
import hb from "./library/hb.json";
import hbicon from "./library/hb.svg";
import hb3b7 from "./library/hb3b7.json";
import hb3b7icon from "./library/hb3b7.svg";
import hb3b7f from "./library/hb3b7f.json";
import hb3b7ficon from "./library/hb3b7f.svg";
import hb7b3 from "./library/hb7b3.json";
import hb7b3icon from "./library/hb7b3.svg";
import hb7b3f from "./library/hb7b3f.json";
import hb7b3ficon from "./library/hb7b3f.svg";
import hb3b3b3 from "./library/hb3b3b3.json";
import hb3b3b3icon from "./library/hb3b3b3.svg";
import b3b3b3f from "./library/b3b3b3f.json";
import b3b3b3ficon from "./library/b3b3b3f.svg";
import hb5b5 from "./library/hb5b5.json";
import hb5b5icon from "./library/hb5b5.svg";
import b5b5f from "./library/b5b5f.json";
import b5b5ficon from "./library/b5b5f.svg";
import hbf from "./library/hbf.json";
import hbficon from "./library/hbf.svg";
import hb5b5f from "./library/hb5b5f.json";
import hb5b5ficon from "./library/hb5b5f.svg";
import hb3b3b3f from "./library/hb3b3b3f.json";
import hb3b3b3ficon from "./library/hb3b3b3f.svg";
import b5b5 from "./library/b5b5.json";
import b5b5icon from "./library/b5b5.svg";
import h7h3b7b3 from "./library/h7h3b7b3.json";
import h7h3b7b3icon from "./library/h7h3b7b3.svg";
import h3h7b3b7 from "./library/h3h7b3b7.json";
import h3h7b3b7icon from "./library/h3h7b3b7.svg";
import h5h5b5b5 from "./library/h5h5b5b5.json";
import h5h5b5b5icon from "./library/h5h5b5b5.svg";


export interface Layout {
    layout: BaseLayer;
    icon: string;
    name: string;
}

const layoutMap: {
    [key: string]: Layout;
} = {
    hb: { layout: hb as BaseLayer, icon: hbicon, name: "Header and body" },
    bf: { layout: bf as BaseLayer, icon: bficon, name: "Body with footer" },
    hb7b3: { layout: hb7b3 as BaseLayer, icon: hb7b3icon, name: "Header, body with split 70/30" },
    
    hb3b7: { layout: hb3b7 as BaseLayer, icon: hb3b7icon, name: "Header, body with split 30/70" },
    h7h3b7b3: { layout: h7h3b7b3 as BaseLayer, icon: h7h3b7b3icon, name: "Header 70/30, body 70/30" },
    h3h7b3b7: { layout: h3h7b3b7 as BaseLayer, icon: h3h7b3b7icon, name: "Header 30/70, body 30/70" },
    
    b7b3f: { layout: b7b3f as BaseLayer, icon: b7b3ficon, name: "Body with split 70/30 and footer" },
    b3b7f: { layout: b3b7f as BaseLayer, icon: b3b7ficon, name: "Body with split 30/70 and footer" },
    hb3b3b3: { layout: hb3b3b3 as BaseLayer, icon: hb3b3b3icon, name: "Header, body with split 30/30/30" },
    
    b3b3b3f: { layout: b3b3b3f as BaseLayer, icon: b3b3b3ficon, name: "Body with split 30/30/30 and footer" },
    h5h5b5b5: { layout: h5h5b5b5 as BaseLayer, icon: h5h5b5b5icon, name: "Header 50/50, body 50/50" },
    b5b5f: { layout: b5b5f as BaseLayer, icon: b5b5ficon, name: "Body with split 50/50 and footer" },
    
    hb5n5: { layout: hb5b5 as BaseLayer, icon: hb5b5icon, name: "Header and body with split 50/50" },
    hbf: { layout: hbf as BaseLayer, icon: hbficon, name: "Header, body, and footer" },
    hb7b3f: { layout: hb7b3f as BaseLayer, icon: hb7b3ficon, name: "Header, body with split 70/30 and footer" },
    
    hb3b7f: { layout: hb3b7f as BaseLayer, icon: hb3b7ficon, name: "Header, body with split 30/70 and footer" },
    hb5b5f: { layout: hb5b5f as BaseLayer, icon: hb5b5ficon, name: "Header, body with split 50/50 and footer" },
    hb3b3b3f: { layout: hb3b3b3f as BaseLayer, icon: hb3b3b3ficon, name: "Header, body with split 30/30/30 and footer" },
    
    b7b3: { layout: b7b3 as BaseLayer, icon: b7b3icon, name: "Body with split 70/30" },
    b3b7: { layout: b3b7 as BaseLayer, icon: b3b7icon, name: "Body with split 30/70" },
    b5b5: { layout: b5b5 as BaseLayer, icon: b5b5icon, name: "Body with split 50/50" },
    
};

export default layoutMap;
